import { formatRawFilterValuesData } from "../format/formatRawFilterValuesData.js";
const createRawFilterValuesItem = (data, parameters) => {
  return {
    id: `${+/* @__PURE__ */ new Date()}`,
    envId: parameters.envId,
    spaceId: parameters.spaceId,
    collectionId: parameters.collectionId,
    data: formatRawFilterValuesData(data),
    parameters
  };
};
export {
  createRawFilterValuesItem
};
